import React, { useEffect, useState } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Outlet, Link, useSearchParams, useNavigate } from "react-router-dom";
import { Menu, Row, Col, Avatar } from 'antd';

const ClassTab = ({
    titles,
    items
}) => {
    const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
    const navigate = useNavigate();
    // const titles = {
    //     '/cramSchool/admin/LessonCategoryList': '課程分類基本資料管理',
    //     '/cramSchool/admin/LessonList': '課程基本資料管理',
    //     '/cramSchool/admin/ClassList': '班級基本資料管理',
    // }
    // const item = [
    //     {
    //         key: "/cramSchool/admin/ClassList",
    //         label: `班級基本資料管理`,
    //     },
    //     {
    //         key: "/cramSchool/admin/LessonList",
    //         label: '課程基本資料管理',
    //     },
    //     {
    //         key: "/cramSchool/admin/LessonCategoryList",
    //         label: `課程分類基本資料管理`,
    //     },
    // ]
    useEffect(() => {
        setSelectedKeys([window.location.pathname])
        document.title = titles[window.location.pathname.key]
    }, [window.location.pathname])
    const onSelect = (e) => {
        navigate(e.key)
        document.title = titles[e.key]
        setSelectedKeys([e.key])
    }
    return (
        <>
            <Menu
                onSelect={onSelect}
                selectedKeys={selecte_keys}
                mode="horizontal"
                items={items}
            // style={{ position: 'relative', display: 'flex', justifyContent: 'center' }} 
            />
            {/* <div style={{ minHeight: '60vh' }}>
                <Outlet />
            </div> */}
        </>
    )

};
export default ClassTab;